module.exports = __webpack_public_path__ + "static/img/7.134925b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fafafa/7.png
// module id = SubA
// module chunks = 0